import React from "react";
import styled, { withTheme } from "styled-components";
import Paper from "../../ui-library/Paper/Paper";
import TargetItem from "./TargetItem";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";

const ButtonsWrapper = styled.div`
  position: initial;
  margin-top: -50px;
  float: right;
`;

const ActionButton = styled(PrimaryButton)`
  padding: 5px 10px !important;

  &:last-child {
    margin-left: 4px;

    @media (max-width: 1024px) {
      margin-right: 1.25rem;
    }
  }
`;

const IconWithRtl = styled.i`
  transform: ${(props) => props.isRtl && "scaleX(-1)"};
`;

const Targets = (props) => {
  const {
    goalsList,
    canCreateNewTarget,
    onEdit,
    canViewTargetsHistory,
    onViewHistory,
    isRtl,
  } = props;

  const { t } = useTranslation();

  return (
    <Paper header={t("appText.dietDiary.targets.title")} data-testid="goals">
      <ButtonsWrapper key="buttons-wrapper">
        {canViewTargetsHistory && (
          <ActionButton
            data-testid="view-history-button"
            size="sm"
            onClick={onViewHistory}
          >
            <IconWithRtl className="fas fa-history" isRtl={isRtl} />
          </ActionButton>
        )}

        {canCreateNewTarget && (
          <ActionButton
            data-testid="edit-button"
            size="sm"
            onClick={() => onEdit()}
          >
            <i className="fas fa-plus" />
          </ActionButton>
        )}
      </ButtonsWrapper>

      {!goalsList && <LoadingSpinner />}

      {goalsList?.map(function (item, index) {
        return <TargetItem data-testid="goal-item" key={index} {...item} />;
      })}
    </Paper>
  );
};
export default withTheme(Targets);
